import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { useRoute } from "vue-router";
import { NavOption } from "@/types";
import { appStore, projectStore } from "@/hooks";
import { QueryParams, Routes } from "@/router";
import { List, ListItem, Separator } from "@/components/common";
import { OnboardingCallout } from "@/components/onboarding";


/**
 * Renders the navigation drawer.
 */
const __default__ = {
  name: "NavOptions",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const currentRoute = useRoute();

const sidebarOpen = computed(() => appStore.popups.navPanel);
const hideProjectOptions = computed(() => !projectStore.isProjectDefined);

const options = computed(() => {
  const query = {
    [QueryParams.VERSION]: projectStore.versionId,
  };

  const items: NavOption[] = [
    {
      label: "Create Project",
      iconTitle: !sidebarOpen.value ? "Create" : undefined,
      icon: "project-add",
      path: Routes.PROJECT_CREATOR,
      color: Routes.PROJECT_CREATOR === currentRoute.path ? "primary" : "text",
    },
    {
      label: "Open Project",
      iconTitle: !sidebarOpen.value ? "Projects" : undefined,
      icon: "nav-open",
      path: Routes.MY_PROJECTS,
      color: Routes.MY_PROJECTS === currentRoute.path ? "primary" : "text",
    },
    {
      label: "Project View",
      iconTitle: !sidebarOpen.value ? "View" : undefined,
      icon: "nav-artifact",
      disabled: hideProjectOptions.value,
      path: { path: Routes.ARTIFACT, query },
      color: Routes.ARTIFACT === currentRoute.path ? "primary" : "text",
    },
    {
      label: "Settings",
      iconTitle: !sidebarOpen.value ? "Settings" : undefined,
      icon: "nav-settings",
      disabled: hideProjectOptions.value,
      path: { path: Routes.PROJECT_SETTINGS, query },
      color: Routes.PROJECT_SETTINGS === currentRoute.path ? "primary" : "text",
    },
  ];

  return items.filter(({ disabled }) => !disabled);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(OnboardingCallout)),
    _createVNode(_unref(List), { items: options.value }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.label
          }, [
            (item.divider)
              ? (_openBlock(), _createBlock(_unref(Separator), { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(_unref(ListItem), {
              to: item.path,
              "data-cy": 'button-nav-' + item.label,
              icon: item.icon,
              title: item.label,
              "icon-title": item.iconTitle,
              color: item.color
            }, null, 8, ["to", "data-cy", "icon", "title", "icon-title", "color"])
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["items"])
  ], 64))
}
}

})